export interface PriorityClass {
    AccountPriorityId:number
    Priority:string
    PriorityOrder:number
    AccountId: number
    IsDeleted: boolean
    IsDisabled: boolean
    isSelected:number
}

const common = {    
    Priority:"",
    PriorityOrder:0,
    IsDisabled:false,
    IsDeleted:false
  };
  
  export const PriorityInitialsForAdd = { ...common };
  
  export const PriorityInitialsForUpdate = {
    ...common,
    AccountPriorityId:0
  };
  


// export const PriorityInitialsForApp={
//     Priority:"",
//     PriorityOrder:0,
//     IsDisabled:false,
//     IsDeleted:false
// }

// export const PriorityInitialsForUpdate={
//     AccountPriorityId:0,
//     Priority:"",
//     PriorityOrder:0,
//     IsDisabled:false,
//     IsDeleted:false
// }

